import React from 'react';
import InvestorSecondaryMarketSC from './investor-secondary-market.styled';
import InfoBanner from '../../../components/info-banner';
import ContentWrap from '../../../components/content-wrap';
import InvestorSecondaryMarketBanner from '../../../components/investor-secondary-market-banner';
import InvestorSecondaryMarketContent from '../../../components/investor-secondary-market-content';

const InvestorSecondaryMarket = () => {
  return (
    <InvestorSecondaryMarketSC>
      <InfoBanner>
        <InvestorSecondaryMarketBanner />
      </InfoBanner>
      <ContentWrap>
        <InvestorSecondaryMarketContent />
      </ContentWrap>
    </InvestorSecondaryMarketSC>
  );
};

export default InvestorSecondaryMarket;
